exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert[data-v-12208302]{height:42px;background:#edf5ff;border:1px solid #97c3ff;border-radius:6px;line-height:42px;font-size:13px;font-weight:400;color:#606266;padding-left:20px;margin-bottom:30px}.look[data-v-12208302]{color:#1890ff;font-style:italic;cursor:pointer}\n", ""]);

// exports
